export class archivos {
    static get PROPIEDADES_EXPORTAR() {
      return [
        {
          value: "IdSec",
          label: "Id",
        },
        {
          value: "Nombre",
          label: "Nombre",
        },
        {
          value: "Payload",
          label: "Payload",
        },
        {
          value: "Estatus",
          label: "Estatus",
        },
        {
          value: "Tipo",
          label: "Tipo",
        },
        {
          value: "Error",
          label: "Error",
        },
        {
            value: "CrearUsuario",
            label: "Usuario Creación",
        },
        {
            value: "FechaCreacion",
            label: "Fecha Creacion",
        },
        {
            value: "ActualizarUsuario",
            label: "Usuario Actualización",
        },
        {
            value: "FechaActualizacion",
            label: "Fecha Actualización",
        },
      ];
    }
  }
  